import { render, staticRenderFns } from "./LadaNewItems.vue?vue&type=template&id=355483fb"
import script from "./LadaNewItems.vue?vue&type=script&lang=js"
export * from "./LadaNewItems.vue?vue&type=script&lang=js"
import style0 from "./LadaNewItems.vue?vue&type=style&index=0&id=355483fb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports